export default "__VITE_ASSET__BBfFBSkg__"